import { BoundingBox } from './bounding-box';

export interface TransformedPhoto {
    photoId: string;
    thumbnail?: string;
    list?: string;
    medium?: string;
    gallery?: string;
    large?: string;
    fullSize?: string;
    plusSize?: string;

    rotation?: number;
    crop?: BoundingBox;
}
